import { Box, Flex, Text } from '@chakra-ui/react'

import { IncidentPriority } from '@/graphql/generated/schemas'

import { PriorityCritical } from './PriorityCritical'

interface PriorityIconIProps {
  priority: IncidentPriority | null | undefined
  fillColor?: string
  showTextIfNoPriority?: boolean
}

const EMPTY_COLOR = 'rgba(0, 0, 0, 0.05)'
const DEFAULT_FILL_COLOR = '#A0A0A0'

const BAR_HEIGHTS = [4, 9, 14]
const BAR_WIDTH = 4

const getFilledBarsCount = (priority: IncidentPriority) => {
  switch (priority) {
    case IncidentPriority.High:
      return 3
    case IncidentPriority.Medium:
      return 2
    case IncidentPriority.Low:
      return 1
    default:
      return 0
  }
}

export const PriorityIcon = ({
  priority,
  fillColor = DEFAULT_FILL_COLOR,
  showTextIfNoPriority = true,
}: PriorityIconIProps) => {
  if (priority === null && showTextIfNoPriority) {
    return (
      <Text color='gray.500' fontSize='12px'>
        No Priority
      </Text>
    )
  }
  if (priority === IncidentPriority.Critical) {
    return <PriorityCritical height={20} width={20} />
  }

  const filledBarsCount = getFilledBarsCount(priority)

  return (
    <Flex
      alignItems='flex-end'
      gap='2px'
      h='20px'
      justifyContent='center'
      pb='2px'
      w='20px'
    >
      {BAR_HEIGHTS.map((height, index) => (
        <Box
          bgColor={index < filledBarsCount ? fillColor : EMPTY_COLOR}
          borderRadius='1px'
          h={`${height}px`}
          key={index}
          w={`${BAR_WIDTH}px`}
        />
      ))}
    </Flex>
  )
}
